import { EditorState } from '../types';

export const toggleTimelineCollapsed = (state: EditorState): EditorState => {
  return {
    ...state,
    isTimelineCollapsed: !state.isTimelineCollapsed,
  };
};
